module.exports = __webpack_public_path__ + "img/error_red.d2b65d22.png";